import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const Label = styled.div`
  font-family: Lato;
  font-size: 16px;
  color: ${colors.black};
  margin-bottom: ${props => props.$marginBottom || '0px'};
`;

export const UnitsLabel = styled.span`
  font-family: Lato;
  font-size: 16px;
  color: ${colors.pelicanBay};
  padding-right: 5px;
`;

export const LabelledInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr ${props => props.$withUnits ? 'min-content' : ''} 160px;
  align-items: center;
`;
